<nz-alert *ngIf="showError"
          nzType="error"
          [nzMessage]="message">
</nz-alert>
